import { AddressTypes, IAddress } from './address'
import { formatString } from '@cbgms/base/utils/helpers'

export const formatAddressPostalCodeThenCity = (address: Partial<IAddress>, type: AddressTypes) => {
  if (type === 'Visitor') {
    return formatString(address.VisitorPostalCode, address.VisitorCity)
  }

  return formatString(address.PostalPostalCode, address.PostalCity)
}
